import axiosInstance from "../../../Utils/axiosInstance";

export const notificationApi = async () => {
    try {
        const response = await axiosInstance.get(
            "api/sourcing_management/getPartnersNotification"
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

interface Payload {
    notifierID: string;
}
export const notificationUpdateReadStatusApi = async (payload: Payload) => {
    try {
        const response = await axiosInstance.post(
            "api/general/updateViewedTime",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
